import { Component, Input } from '@angular/core';
import { EventsProvider } from '../../providers/events/events';
import moment from 'moment';
import { Platform } from 'ionic-angular/platform/platform';
import { CoEventPopupDetailsPage } from '../../pages/co-event-popup-details/co-event-popup-details';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';
import { ModalController } from 'ionic-angular';
import { FilteringProvider } from '../../providers/filtering/filtering';

/**
 * Generated class for the CoWeekCalendarViewComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-week-calendar-view',
  templateUrl: 'co-week-calendar-view.html',
  inputs: ['currentDate', 'clientKeyword']
})
export class CoWeekCalendarViewComponent {
  @Input('currentDate') currentWeek: any; //not actually current week but the the current date within the week
  eventsCheck: boolean = false;
  rawQueryData: any;
  startingDay: any;
  endingDay: any;
  filteredWeek: any;
  searchTypes: any;
  eventsArray: any;
  @Input('popOverFilter') popOverFilter: any;
  timeHourHeaders: any = [];
  weekDays: any = [];
  currentPopper: any;
  currentEvent: any;
  public devWidth = this.platform.width();
  popoverContent: any;
  hovering: boolean = false;
  clientKeyword: any;
  viewType: any;
  screenWidth: any;
  aboveWidthBreakpoint: any;

  constructor(public eventsProvider: EventsProvider, public platform: Platform, private clientDetails: ClientDetailsProvider, public state: AppState, public modalCtrl: ModalController, public filteringProvider: FilteringProvider) {
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = state.mode;
      self.screenWidth = self.platform.width();
      self.platform.width() > 992 ? self.aboveWidthBreakpoint = true : self.aboveWidthBreakpoint = false;
    });
  }

  ngOnInit() {
    this.initializeCalendar(this.currentWeek);
  }

  initializeCalendar(currentDate) {
    let eventsQueryArgs = `startDate: "${moment(currentDate).startOf('week').subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(currentDate).endOf('week').subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(eventsQueryArgs);
    this.startingDay = moment(currentDate).startOf('week').format("YYYY-MM-DD HH:mm:ss");
    this.endingDay = moment(currentDate).endOf('week').format("YYYY-MM-DD HH:mm:ss");
    this.changeWeek();
  }

  changeWeek() {
    this.weekDays = [];
    for (let i = 0; i < 7; i++) {
      this.weekDays.push(moment(this.startingDay).add(i, 'day').format("YYYY-MM-DD HH:mm:ss"));
    }
  }

  queryEvents(args) {
    let eventsResponse;
    this.eventsProvider.getEvents(args).then((res) => {
      eventsResponse = res.allEvents;
      this.rawQueryData = res.allEvents;
      this.filteredWeek = res.allEvents;
      this.searchTypes = res.searchTypes;
      this.currentEvent = res.allEvents[0]
      // this.splitByDay(eventsResponse)
      eventsResponse.length > 0 ? this.eventsCheck = true : this.eventsCheck = false;
      this.filterByPopOver(this.popOverFilter);
    });
  }

  filterByPopOver(filterObj){
    this.filteringProvider.filterByPopover(filterObj, this.rawQueryData).then((res)=>{
      this.rebuildPage(res);
    })
  }

  rebuildPage(info){
    let hourObject = info.reduce((red, event) => {
      let currentEventTime = moment(event.eventStart).format("HH");
      if (!red[currentEventTime]) {
        red[currentEventTime] = [];
      };
      red[currentEventTime].push(event);

      return red;
    }, {});

    let hourArray = Object.keys(hourObject).map((key) => {
      return hourObject[key];
    });

    hourArray.sort(function (a, b) {
      return moment(a[0].eventStart).hour() - moment(b[0].eventStart).hour();
    });

    this.timeHourHeaders = [];
    for (let i = 0; i < hourArray.length; i++) {
      this.timeHourHeaders.push(hourArray[i][0].eventStart);
    }

    let dayArray = [];

    //events seperated by hours, for each hour
    hourArray.forEach((array, h) => {
      //define array for days of week
      let outputDayArray = [[], [], [], [], [], [], []];
      //for each day
      outputDayArray.forEach((day, i) => {
        //for each hour array
        array.forEach((event, j) => {
          //if its same day as week
          if (i === moment(event.eventStart).day()) {
            // event.eventStart = moment(event.eventStart).toString()
            day.push(event)
          }
        })
      });
      dayArray.push(outputDayArray);

    });
    this.eventsArray = dayArray;
  }

  getEventColor(eventType, barOrText) {
    if (barOrText == 'text') {
      try {
        let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
        return eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
    else {
      try {
        let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
        return "2px solid " + eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
  }

  expandCell(data) {
    // console.log(data);
  }

  // toggleHover(info, toggle, currentEvent) {
  //   this.currentEvent = currentEvent;
  //   const reference = info.target.firstChild.parentElement.parentElement.parentElement;
  //   const onPopper = document.querySelector('#eventSnapshotPopper');
  //   const arrow = document.querySelector('#arrowPopper');
  //   this.hovering = true;
  //   if (toggle && onPopper != null) {
  //     let popper: any;
  //     popper = new Popper(reference, onPopper, {
  //       placement: 'right-start',
  //       modifiers: {
  //         keepTogether: {
  //           enabled: false
  //         },
  //       },
  //       onCreate: (data) => {
  //           // popper.popper.style.display = "block";
  //       },
  //     });
  //     this.currentPopper = popper;

  //   }
  //   else {
  //     this.hovering = false;
  //     // this.currentPopper.popper.style.display = "none";
  //     this.currentPopper.destroy();
  //   }
  // }

  openEventCard(currentEvent) {
    let modal = this.modalCtrl.create(CoEventPopupDetailsPage, { currentEvent: currentEvent, searchTypes: this.searchTypes, clientKeyword: this.clientKeyword },{ cssClass: 'eventDetailsModal' });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/co-week-calendar-view/co-week-calendar-view.ts